package com.hyperether.goodjob.repository.remote.model

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class UploadFileResponse(
    @SerialName("fileId") var fileId: String? = null,
    @SerialName("message") var message: String? = null
)
